import React from 'react'
import { dayjs } from '@mobi/utils/date'
import { machineFormat, dateTimeFormat } from '../../helpers'

export const LastUpdated = ({ date }: { date: string }) => {
  return (
    <div data-tid-updated-datetime className='fz-11 pt1em pb1em text-center w100'>
      Last Updated at{' '}
      <time dateTime={displayLocalTime(date, machineFormat)}>
        {displayLocalTime(date, dateTimeFormat)}
      </time>
    </div>
  )
}

const displayLocalTime = (date: string, format: string) => {
  const regExp = /\(([^)]+)\)/
  const matches = regExp.exec(date)

  if (!matches || !matches[1]) return ''
  const timeInMs = Number(matches[1].split('+')[0])

  if (!timeInMs) return ''

  return dayjs(dayjs.utc(new Date(timeInMs).toISOString()).utcOffset('+08:00'))
    .local()
    .format(format)
}
